module.exports = __webpack_public_path__ + "img/northeast-summer-1920x550.86007159.jpg";